import { defineMessages } from 'react-intl';

const messages = defineMessages({
  connectionTitle: {
    id: 'features.termsOfUse.connectionTitle',
    defaultMessage: '{organizationName} Terms of Use',
  },
  connectionAcceptLabel: {
    id: 'features.termsOfUse.connectionAcceptLabel',
    defaultMessage: 'I have read and accept these Terms of Use',
  },
  loading: {
    id: 'features.termsOfUse.loading',
    defaultMessage: 'Loading Terms of Use…',
  },
  loadError: {
    id: 'features.termsOfUse.loadError',
    defaultMessage: 'Terms of Use could not be loaded. Please try again.',
  },
  enterTermsOfUseTitle: {
    id: 'features.termsOfUse.enterTermsOfUseTitle',
    defaultMessage: 'Enter Terms of Use',
  },
  enterTermsOfUseDescription: {
    id: 'features.termsOfUse.enterTermsOfUseDescription',
    defaultMessage:
      'Complete this form before sending the invite. The invitee will see your answers as the Terms of Use they must accept to confirm it. You can edit your answers at any time.',
  },
  purchaseUnavailable: {
    id: 'features.termsOfUse.purchaseUnavailable',
    defaultMessage:
      'This item is currently unavailable for purchase because the seller has not provided Terms of Use. Please try again later.',
  },
  // The platform-wide legal disclaimer shown wherever a marketplace Terms of
  // Use is presented — to the org filling it out and to the client accepting
  // it at checkout. Fixed wording, not editable per-org.
  disclaimer: {
    id: 'features.termsOfUse.disclaimer',
    defaultMessage:
      "Disclaimer: MyFitWorld is not involved in shaping the merchant's business model or its policies on payment, scheduling and cancellation, complaints, and refunds. As such, MyFitWorld is not and cannot be held responsible for any disputes arising between the merchant and the end user. Please read the merchant's terms of cooperation carefully before accepting them. If you are unsure about the transparency of any of the terms, contact the merchant by the email or phone number listed in this document before accepting.",
  },
  mandatoryFieldsNote: {
    id: 'features.termsOfUse.mandatoryFieldsNote',
    defaultMessage:
      'Popunjavanje sekcija je obavezno. U slučaju da su kontakt podaci nerelevantni ili lažni (ne odgovaraju identitetu entiteta koje prodaje sadržaj i pretplate na MFW platformi), MFW zadržava pravo da bez najave ukloni korisnika sa pozicija na MFW platformi koje omogućavaju prodaju sadržaja, proizvoda i pretplata ili da potpuno ukloni korisnika sa platforme.',
  },
  contactSectionTitle: {
    id: 'features.termsOfUse.contactSectionTitle',
    defaultMessage: 'Contact',
  },
  contactEmail: {
    id: 'features.termsOfUse.contactEmail',
    defaultMessage: 'Email',
  },
  contactPhone: {
    id: 'features.termsOfUse.contactPhone',
    defaultMessage: 'Phone',
  },
  contactWebsite: {
    id: 'features.termsOfUse.contactWebsite',
    defaultMessage: 'Website',
  },
  contactInstagram: {
    id: 'features.termsOfUse.contactInstagram',
    defaultMessage: 'Instagram',
  },
  contactLinkedin: {
    id: 'features.termsOfUse.contactLinkedin',
    defaultMessage: 'LinkedIn',
  },
  contactTiktok: {
    id: 'features.termsOfUse.contactTiktok',
    defaultMessage: 'TikTok',
  },
  // Titles for the fixed, platform-wide question catalog (see
  // `TermsOfUseQuestion` — one universal set of questions for the whole
  // platform, not org-authored). The seeded `questionText` from the backend
  // is a bilingual literal, not react-intl-localized, so the buyer-facing
  // dialog shows these translated titles instead — mirrors
  // `OrgTermsOfUseForm`'s `TRANSLATED_QUESTIONS` map.
  businessModelTitle: {
    id: 'features.termsOfUse.businessModelTitle',
    defaultMessage: 'Business Model',
  },
  businessModelDescription: {
    id: 'features.termsOfUse.businessModelDescription',
    defaultMessage:
      "In this section, describe the way you sell your products and services. It is preferable to describe the entire process: from the moment the user selects the content, to the moment the product and/or service comes into the user's ownership/possession. Describe what is included in the price of the service/product, who it is intended for and in what way (if you sell several different types of products and services, you can describe the general concept, along with the specifics that users need to be aware of before purchasing and/or subscribing). Describe your general business model and the type of your products and services.",
  },
  paymentPolicyTitle: {
    id: 'features.termsOfUse.paymentPolicyTitle',
    defaultMessage: 'Payment Policy',
  },
  paymentPolicyDescription: {
    id: 'features.termsOfUse.paymentPolicyDescription',
    defaultMessage:
      "In this section, describe all the costs included in the displayed price of the product and/or services, whether there are additional costs, and under what conditions they apply.\n\nAlso describe whether the price is final, an initial price, one-time, or recurring, as well as whether the charge is made automatically or whether each subsequent billing cycle must be manually initiated (only in the case of subscriptions).\n\nDescribe the reservation, complaint, and refund conditions.\n\nDescribe whether there are special conditions that apply after the user's initial payment/subscription.\n\nIf you sell different types of products/subscriptions/services, you need to write a general policy on reservations, billing, complaints, and refunds, but also highlight special conditions if they exist for certain products/services/subscriptions.\n\nIt is ideal to add a description with a few concrete practical examples: what is an allowed scenario and what is a disallowed scenario.\n\nIt is necessary to specify whether the purchased/subscribed content belongs to the user forever after payment, or whether the payment/subscription represents the right to use the product and/or services for a certain period (with the duration of the usage period clearly stated).",
  },
});

export default messages;
